import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import type IBox from '../receiving/ReceivingInterfaces';

interface MarkBoxDamagedDialogProps {
  onClose: () => void;
  damagedBox: IBox;
  handleMarkDamaged: (description: string, accept: boolean) => void;
  open: boolean;
}

const MarkBoxDamagedDialog: React.FC<MarkBoxDamagedDialogProps> = (props) => {
  const {
    open, onClose, handleMarkDamaged, damagedBox,
  } = props;

  const [description, setDescription] = React.useState<string>('');
  const descriptionMaxLength = 50;

  const isMacys = damagedBox.client === "Macy's";

  const handleSetDescription = (text: string) => {
    if (description.length < descriptionMaxLength) {
      setDescription(text);
    }
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <Box m={2}>
        <Typography variant="subtitle2">
          {'DAMAGED BOX - #'}
          {damagedBox.trackingNumber}
        </Typography>
        <DialogTitle>
          <Typography variant="h6" color="primary">{'Would you like to receive or reject this box?'}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">{"Please note, that for Macy's boxes we have to receive no matter what."}</Typography>
          </DialogContentText>
          <TextField
            autoFocus
            inputProps={{ maxLength: descriptionMaxLength }}
            fullWidth
            defaultValue={description}
            onChange={(e) => { handleSetDescription(e.target.value); }}
            label="Detail the damage on the box"
            variant="outlined"
          />
          <Box display="flex" flexDirection="row-reverse">
            <Typography variant="caption">
              {description.length}
              {'/50'}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isMacys}
            variant="contained"
            color="secondary"
            onClick={() => {
              handleMarkDamaged(description, true);
              setDescription('');
              onClose();
            }}
          >
            {'REJECT BOX'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleMarkDamaged(description, false);
              setDescription('');
              onClose();
            }}
          >
            {'RECEIVE BOX'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default MarkBoxDamagedDialog;
